import { h, Component } from 'preact';
import { IEmptyState, ISignOutLinkProps } from '../sgwt-super-header.types';
import { widgetConfiguration } from '@sgwt-widget/core';
const NavItem = require('react-bootstrap/lib/NavItem');

export default class SignOutLink extends Component<ISignOutLinkProps, IEmptyState> {
  constructor(props: ISignOutLinkProps) {
    super(props);
  }

  /**
   * Get the SGWT Connect interface, either from <sgwt-connect> widget or from `window.sgwtConnect` variable.
   * @returns {any}
   */
  private getSGWTConnect() {
    // First, try to retrieve the <sgwt-connect> widget...
    const sgwtConnectWidget = document.querySelector('sgwt-connect');
    if (sgwtConnectWidget) {
      return sgwtConnectWidget;
    }
    // Now, find the sgwtConnect instance in window.
    return (window as any).sgwtConnect;
  }

  /**
   * Can we discard the SG Connect v2 token? Yes if:
   *   - sg-connect-v2 mode is set;
   *   - SGWT Connect library is available through:
   *     - the <sgwt-connect> widget;
   *     - the `sgwtConnect` instance is available in `window`.
   * @returns {boolean}
   */
  private isDiscardTokenCapable() {
    if (this.props.sgConnectSupport && this.props.sgConnectSupport === 'sg-connect-v2') {
      // Search for the <sgwt-connect> widget in the page...
      const sgwtConnect = this.getSGWTConnect();
      if (sgwtConnect) {
        return true;
      } else {
        widgetConfiguration().warn(
          'The widget is configured with the mode "sg-connect-v2" but the <sgwt-connect> widget has not been' +
          ' found on the page, not the window.sgwtConnect instance. Thus, the SG Connect token cannot be discarded.'
        );
      }
    }
    return false;
  }

  redirectToLogoutLink() {
    if (this.props.signOutLink) {
      window.location.href = this.props.signOutLink;
    }
  }

  signOut() {
    this.props.onSignOut();
    if (this.isDiscardTokenCapable()) {
      const sgwtConnect: any = this.getSGWTConnect();
      if (sgwtConnect && sgwtConnect.discardAuthorization) {
        sgwtConnect.discardAuthorization();
      }
      // Wait for the token to be discarded before the redirection.
      setTimeout(() => {
        this.redirectToLogoutLink();
      }, 250);
    } else {
      this.redirectToLogoutLink();
    }
  }

  render(props: ISignOutLinkProps): JSX.Element {
    if (!props.user || !props.user.mail) {
      return <li class="empty" />;
    }
    return (
      this.isDiscardTokenCapable() ?
      <NavItem
        className="hidden-xs"
        id="sgwt-super-header-sign-out-link"
        onClick={() => this.signOut()}>
        {props.labels.signOut}
      </NavItem> :
      <NavItem
        href={props.signOutLink}
        className="hidden-xs"
        id="sgwt-super-header-sign-out-link"
        onClick={() => props.onSignOut()}>
        {props.labels.signOut}
      </NavItem>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-super-header/components/SignOutLink.tsx